module.exports = __webpack_public_path__ + "6caa98250c220788a3b457685d565123.svg";